module.exports = require("./dist/index");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kenshooui/react-multi-select/index.js
// module id = 199
// module chunks = 0